import { defineComponent as x, inject as E, computed as k, h as t } from "vue";
import { uploadInjectionKey as A } from "./ghl-ui.es1150.js";
import { getFilesFromEntries as F } from "./ghl-ui.es1151.js";
import N from "./ghl-ui.es383.js";
import { throwError as O } from "./ghl-ui.es853.js";
import { resolveSlot as U } from "./ghl-ui.es860.js";
import P from "./ghl-ui.es862.js";
import $ from "./ghl-ui.es1003.js";
const q = x({
  name: "UploadTrigger",
  props: {
    abstract: Boolean
  },
  setup(c, {
    slots: l
  }) {
    const u = E(A, null);
    u || O("upload-trigger", "`n-upload-trigger` must be placed inside `n-upload`.");
    const {
      mergedClsPrefixRef: D,
      mergedDisabledRef: o,
      maxReachedRef: i,
      listTypeRef: h,
      dragOverRef: a,
      openOpenFileDialog: R,
      draggerInsideRef: T,
      handleFileAddition: y,
      mergedDirectoryDndRef: C,
      triggerClassRef: b,
      triggerStyleRef: I
    } = u, g = k(() => h.value === "image-card");
    function f() {
      o.value || i.value || R();
    }
    function v(e) {
      e.preventDefault(), a.value = !0;
    }
    function p(e) {
      e.preventDefault(), a.value = !0;
    }
    function s(e) {
      e.preventDefault(), a.value = !1;
    }
    function m(e) {
      var r;
      if (e.preventDefault(), !T.value || o.value || i.value) {
        a.value = !1;
        return;
      }
      const n = (r = e.dataTransfer) === null || r === void 0 ? void 0 : r.items;
      n != null && n.length ? F(Array.from(n).map((d) => d.webkitGetAsEntry()), C.value).then((d) => {
        y(d);
      }).finally(() => {
        a.value = !1;
      }) : a.value = !1;
    }
    return () => {
      var e;
      const {
        value: r
      } = D;
      return c.abstract ? (e = l.default) === null || e === void 0 ? void 0 : e.call(l, {
        handleClick: f,
        handleDrop: m,
        handleDragOver: v,
        handleDragEnter: p,
        handleDragLeave: s
      }) : t("div", {
        class: [`${r}-upload-trigger`, (o.value || i.value) && `${r}-upload-trigger--disabled`, g.value && `${r}-upload-trigger--image-card`, b.value],
        style: I.value,
        onClick: f,
        onDrop: m,
        onDragover: v,
        onDragenter: p,
        onDragleave: s
      }, g.value ? t(N, null, {
        default: () => U(l.default, () => [t(P, {
          clsPrefix: r
        }, {
          default: () => t($, null)
        })])
      }) : l);
    };
  }
});
export {
  q as default
};
